var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"date",attrs:{"title":_vm.formattedDate}},[_vm._v(" "+_vm._s(_vm.relativeTimeformat(_vm.date))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }